"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Icon_1 = __importDefault(require("../Util/Icon"));
const helpers_1 = require("../../lib/helpers");
const Journey_1 = require("../../lib/Journey");
const Button_1 = __importDefault(require("../Util/Button"));
const TextInput_1 = __importDefault(require("./TextInput"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const FormContext_1 = require("../../contexts/FormContext");
const PasswordInput = (props) => {
    var _a;
    const [visible, setVisible] = react_1.useState(false);
    const { value } = props;
    const { formData } = react_1.useContext(FormContext_1.FormContext);
    const inputValue = value !== null && value !== void 0 ? value : formData[(_a = props.name) !== null && _a !== void 0 ? _a : ''];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TextInput_1.default, Object.assign({}, props, { type: visible ? 'text' : 'password', buttons: !helpers_1.isEmpty(inputValue) && (react_1.default.createElement(Button_1.default, { onClick: () => setVisible(!visible) },
                react_1.default.createElement(Icon_1.default, { src: visible ? Journey_1.Journey.icons().HIDE : Journey_1.Journey.icons().SHOW }))) }))));
};
exports.default = withJourney_1.default('j-password-input', PasswordInput);
